import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { MessageSeverity } from '../../../enums/message-severity';
import { ActionButton } from '../../../models/app/action-button';

@Component({
    selector: 'app-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.css', '../../../app.component.css']
})

export class ActionsComponent implements OnInit {

    public visibilityClassName: string = "actions-invisible";
    public actionButtons: ActionButton[] = [];

    public customActionButtons: ActionButton[] = [];
    public applicationActionButtons: ActionButton[] = [];

    public constructor(public appService: AppService) {

        this.appService.actionsDataSourceChanged.subscribe((buttons: any) => {

            this.actionButtons = buttons;
            this.customActionButtons = this.actionButtons.filter(i => i.caption != "APP FEED");
            this.applicationActionButtons = this.actionButtons.filter(i => i.caption == "APP FEED");
            this.visibilityClassName = buttons.length == 0 ? "actions-invisible" : "actions-visible";
        });
    }

    public ngOnInit(): void { }

    public action = (actionName: string): void => {

        this.appService.raiseActionButtonClickedEvent(actionName);
    }
}
